














import { computed, defineComponent, toRefs, watch, watchEffect } from "@vue/composition-api";
import { Group } from "@scrile/api-provider/dist/api/GroupsProvider";
import { useGroupSelection } from "@/hooks/useGroupSelection";
import GroupListSelectionView from "./components/GroupListSelectionView.vue";

export default defineComponent({
  name: "GroupListSelection",
  components: { GroupListSelectionView },
  props: {
    loading: { type: Boolean, required: true },
    groups: { type: Array as () => Group[], required: true },
    selectedGroupIds: { type: Array as () => string[], required: true },
    excludeGroupIds: { type: Array as () => string[], required: true },
    btnIsBottom: { type: Boolean, default: false },
    allowOnlyExclude: { type: Boolean, default: false },
  },
  setup(props, { emit }) {
    const { groups, excludeGroupIds, selectedGroupIds } = toRefs(props);
    const {
      selectedGroupIdsLocal,
      excludeGroupIdsLocal,
      selectedUserIds,
      toggleSelection,
      unmarkGroup,
    } = useGroupSelection(groups);
    const syncStateWithProps = () => {
      selectedGroupIdsLocal.value = [...props.selectedGroupIds];
      excludeGroupIdsLocal.value = [...props.excludeGroupIds];
    };
    emit("setReset", syncStateWithProps);
    watch(
      [selectedGroupIds, excludeGroupIds],
      () => {
        syncStateWithProps();
      },
      { immediate: true }
    );

    const onContinue = () => {
      emit("continue", {
        excludedGroupIds: excludeGroupIdsLocal.value,
        groupIds: selectedGroupIdsLocal.value,
        recipientCount: selectedUserIds.value.length,
      });
    };
    const onMarkGroup = (status: boolean, groupId: string) => {
      toggleSelection(status, groupId, selectedGroupIdsLocal);
      unmarkGroup(groupId, excludeGroupIdsLocal);
    };
    const onMarkExcludedGroup = (status: boolean, groupId: string) => {
      toggleSelection(status, groupId, excludeGroupIdsLocal);
      unmarkGroup(groupId, selectedGroupIdsLocal);
    };

    watchEffect(() => emit("setRecipientCount", selectedUserIds.value.length));

    const allowContinue = computed(
      () =>
        selectedUserIds.value.length > 0 ||
        (props.allowOnlyExclude && selectedGroupIdsLocal.value.length === 0 && excludeGroupIdsLocal.value.length > 0)
    );

    return {
      selectedGroupIdsLocal,
      excludeGroupIdsLocal,
      onContinue,
      onMarkGroup,
      onMarkExcludedGroup,
      allowContinue,
    };
  },
});
